/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/4/21
 * Copyright All Rights Reserved
 */


const getUrlSearchParams = (keys, location) => {
  const params = new URLSearchParams(location.search);
  return keys.reduce((acc, key) => ({
    ...acc,
    [key]: params.get(key),
  }), {});
};

export default getUrlSearchParams;



// WEBPACK FOOTER //
// ./js/support/getUrlSearchParams.js